import React from "react";
import { useOutletContext } from "react-router-dom";
import ProductRecommendationPurchaseFunnel from "../../../../components/ClientDashboard/analytics-components/SalesAndConversionInsight/ProductRecommendationPurchaseFunnel";
import RevenueDrivenbyAIChatbot from "../../../../components/ClientDashboard/analytics-components/SalesAndConversionInsight/RevenueDrivenbyAIChatbot";

export default function SalesAndConversionInsightAnalytics() {
  const { dateFilterValue } = useOutletContext();

  return (
    <>
      <ProductRecommendationPurchaseFunnel dateFilterValue={dateFilterValue} />
      <RevenueDrivenbyAIChatbot dateFilterValue={dateFilterValue} />
    </>
  );
}


